import moment from "moment";
import { useCallback, useEffect, useState } from "react";

import { DATE_FORMATS } from "../../../shared";

export const useGivenTimeInterval = (dateFrom: string, dateTo: string) => {
  const [isGivenTimeGap, setIsGivenTimeGap] = useState<boolean>(true);

  const checkIfIsGivenTimeGap = useCallback((): boolean => {
    const givenTimeFrom = moment(dateFrom, DATE_FORMATS.DateHoursMinutes);
    const givenTimeTo = moment(dateTo, DATE_FORMATS.DateHoursMinutes);

    return moment().isAfter(givenTimeFrom) && moment().isBefore(givenTimeTo);
  }, [dateFrom, dateTo]);

  useEffect(() => {
    setIsGivenTimeGap(checkIfIsGivenTimeGap());
  }, [checkIfIsGivenTimeGap]);

  return { isGivenTimeGap };
};
